/**
 * External dependencies
 */
import Immerable from '@naruto/naruto-reducers/src/types/GeneralImmer';

/**
 * Internal dependencies
 */
import { SiteMetaInfo } from './types';

class SiteMeta extends Immerable {
  public siteMetaInfo: SiteMetaInfo;

  public constructor() {
    super();
    this.siteMetaInfo = {
      project_slots: []
    };
  }

  public initialize(): void {
    this.siteMetaInfo = {
      project_slots: []
    };
  }

  public updateSiteMetaInfo(newSiteMeta: SiteMetaInfo): void {
    this.siteMetaInfo = newSiteMeta;
  }
}

export default SiteMeta;
